import { conditions } from "helpers";
import { ConditionName } from "interfaces";
import { useAppSelector } from "redux-share/hooks";
import { shallowEqual } from "react-redux";

const AgeClassification = () => {
    const { details } = useAppSelector(({ videoData: { details } }) => ({ details }), shallowEqual);

    const ageClassificationStyles = () => {
        let styles = `pl-bg-white pl-rounded-full pl-text-[12px] pl-font-extrabold
        ${
            conditions(ConditionName.isTouchScreen) ? "pl-w-6 pl-h-6" : "pl-w-8 pl-h-8"
        } pl-flex pl-justify-center pl-items-center animate__animated animate__faster ${
            conditions(ConditionName.isActiveElements) ? "animate__fadeInDown" : "animate__fadeOutUp"
        }`;
        if (conditions(ConditionName.isChildClassification)) styles = `${styles} !pl-bg-lime-success`;
        if (conditions(ConditionName.isTeenagerClassification)) styles = `${styles} !pl-bg-warning-100`;
        if (conditions(ConditionName.isYoungClassification)) styles = `${styles} !pl-bg-red-error pl-text-red-onError`;

        return styles;
    };

    return (
        <div className={`${ageClassificationStyles()}`}>
            <span className="pl-mt-0.5">{details.pg_state}+</span>
        </div>
    );
};

export default AgeClassification;
